<div *ngIf="isLoading" class="se-loader">
</div>
<div class=" p-2">
  <div class="top-div">
    <div class="filter-sec pt-2">
      <input type="text" title={{labels.userSearch|translate}} class="input-globalsearch" aria-label="search" size="50" placeholder={{labels.search|translate}} (input)="dt.filterGlobal($event.target.value, 'contains')">
      <a class="SearchLink">
        <em class="fa fa-search SearchIcon"></em>
      </a>
      <button class="se-button cursorPointerHand" id="btnAddUser" (click)="AddUser()">
        {{labels.btnAddUser|translate}}
      </button>
      <button class="se-button cursorPointerHand" (click)="ExportUser()">
        {{labels.btnExport | translate}}
      </button>
    </div>
  </div>
  <div class="gridtbl-div mb-3">
    <div class="rectangle-grid">
      <p-table #dt [columns]="cols" [value]="userInfo" [paginator]="isPagination" [rows]="10"
               [globalFilterFields]="['name','email','roleDesc','oemName','parentUser','cooler_count']">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" class="ColNum">#</th>
            <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width, 'display': col.display}">
              {{col.header | translate}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
              </p-sortIcon>
            </th>
            <th scope="col" class="tabelCell">{{ labels.actions | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
          <tr class="rowHeight">
            <td>
              {{i+1}}
            </td>
            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
              <span *ngIf="col.field === 'oemName' && rowData.roleCode == rolesConst.oemuser" appendTo="target" class="relativePosition">
                {{ rowData[col.field] ? rowData[col.field] + '-' + rowData[col.data] : '' }}
              </span>
              <span *ngIf="col.field === 'oemName' && [rolesConst.cuserW, rolesConst.cuserR].indexOf(rowData.roleCode) > -1" appendTo="target" class="relativePosition">
                {{ rowData.parentUser }}
              </span>
              <span *ngIf="col.field !== 'oemName'" appendTo="target" class="relativePosition">
                {{ rowData[col.field ]}}
              </span>
            </td>
            <td>
              <button class="icon-action iconEditUser" [disabled]="(rowData.federatedId === authFId) || (currentAuthUserRole === rolesConst.master && [rolesConst.cuserW, rolesConst.cuserR, rolesConst.posowner].indexOf(rowData.roleCode) > -1)" (click)="EditUser(rowData)">
                <img class="icon-action editIcon" src="assets/edit.svg" alt="edit" height="21" width="21"  [ngClass]="{'disabled-icon': ((rowData.federatedId === authFId) || (currentAuthUserRole === rolesConst.master && [rolesConst.cuserW, rolesConst.cuserR, rolesConst.posowner].indexOf(rowData.roleCode) > -1))}" />
              </button>
              <label class="se-block-action switch">
                <input type="checkbox" [(ngModel)]="rowData.isActive" class="user-block-check editUserStatus"
                       [disabled]="(rowData.federatedId === authFId) || (currentAuthUserRole === rolesConst.master && [rolesConst.cuserW, rolesConst.cuserR, rolesConst.posowner].indexOf(rowData.roleCode) > -1)"
                       (click)="onEditUserStatus(rowData, $event)" (keypress)="onEditUserStatus(rowData, $event)"
                       (keydown)="onEditUserStatus(rowData, $event)"
                       (keyup)="onEditUserStatus(rowData, $event)" />
                <span class="slider round" [ngClass]="{'disabled-icon': ((rowData.federatedId === authFId) || (currentAuthUserRole === rolesConst.master && [rolesConst.cuserW, rolesConst.cuserR, rolesConst.posowner].indexOf(rowData.roleCode) > -1))}"></span>
              </label>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr *ngIf="noData">
            <td [attr.colspan]="columns.length+1">
              {{labels.noRecords | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<div class="se-dialog" *ngIf="showDeletemodal">
  <div class="se-dialog-holder">
    <div class="se-complex-header se-warning">
      <h3 class="se-dialiog-title">{{ currentUserRecord.isActive ? this.labels.blockUserHead : this.labels.unblockUserHead }} : {{selectedEmail}}</h3>
    </div>
    <div class="se-dialog-body se-dialog-body-delete">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      {{ currentUserRecord.isActive ? this.messages.blockDevice : this.messages.unblockDevice | translate }}
    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="cancel()">{{ labels.no | translate}}</button>
      <button class="se-button" (click)="onUserStatusChangeConfirm()">{{ labels.yes | translate}}</button>
    </div>
  </div>
</div>

<template ngbModalContainer>
</template>

<p-toast class="mt10" position="top-center" key="success"></p-toast>
<p-toast class="mt10" position="top-center" key="error"></p-toast>
<p-toast position="center" key="c" (onClose)="onReject()" [baseZIndex]="5000"></p-toast>

<div class="se-dialog" *ngIf="ShowDailog">
  <p-toast class="mt10" position="top-center" key="error"></p-toast>
  <div class="se-dialog-holder">
    <div class="se-complex-header">
      <h3 class="se-dialiog-title">{{contentHeader| translate}}</h3>
    </div>
    <div class="se-dialog-body">
      <div *ngIf="this.isLoading" class="se-loader"></div>
      <div class="se-inline-form">
        <div class="form-ele col-md-12">
          <label for="txtEmail" class="se-label col-md-3">{{labels.email | translate}}<span>*</span></label>
          <input id="txtEmail" name="txtEmail" placeholder="Email" autocomplete="off" type="text" class="se-form-control col-md-6" appEmailValidator #userEmail="ngModel" [(ngModel)]="txtEmail" #Email (keyup)="validateForm($event)" (change)="validateForm($event)">
          <div class="d-block brand-error se-fs-12" *ngIf="!userEmail.errors?.emailValidator.isValid && (userEmail.dirty || userEmail.touched)">
            {{ userEmail.errors?.emailValidator.error }}
          </div>
        </div>

        <div class="form-ele col-md-12" *ngIf="showRoles">
          <label for="drpRoleList" class="se-label col-md-3"> {{labels.role | translate}}<span>*</span></label>
          <select id="drpRoleList" class="se-form-control col-md-6" [(ngModel)]="selectedRl" (change)="roleSelectionChanged(selectedRl)" appRequiredElementValidator #Rolecode="ngModel" [minLength]="1" [maxLength]="50" #Role>
            <option value='' disabled>--{{labels.select | translate}} {{labels.role | translate}}--</option>
            <option *ngFor="let item of roleList; let i = index" [ngValue]="item.roleCd">{{item.roleDesc}}</option>
          </select>
          <div class="d-block brand-error se-fs-12" *ngIf="(selectedRl=='' || selectedRl=='undefined' || selectedRl.trim().length==0) && (Rolecode.dirty || Rolecode.touched)">
            {{this.messages.roleMandatory}}
          </div>
        </div>
        <div class="form-ele col-md-12" *ngIf="showOems">
          <label for="drpOem" class="se-label col-md-3"> {{labels.oem | translate}}<span>*</span></label>
          <select id="drpOem" class="se-form-control col-md-6" [(ngModel)]="selectedOemId" (change)="oemIdSelectionChanged(selectedOemId)" #OEMId="ngModel" [minLength]="1" [maxLength]="50" #OEM>
            <option value='' disabled>--{{labels.select | translate}} {{labels.oem | translate}}--</option>
            <option *ngFor="let item of oemIdList; let i = index" [ngValue]="item.key">{{item.value}}</option>
          </select>
        </div>

        <div class="dg-select-device form-ele col-md-12" *ngIf="showRegions">
          <label class="se-label col-md-3 mt-3">{{ labels.selectCountry | translate}}<span>*</span></label>
          <p-multiSelect class="drpCountry col-md-8" [options]="regionData" [(ngModel)]="selectedRegion"
                         placeholder="Select Country" optionValue="countryCd" optionLabel="countryName" (onChange)="validateForm($event)" display="chip"></p-multiSelect>
        </div>


        <div class="form-ele col-md-12" *ngIf="showCreateUser">
          <label class="se-label col-md-3">{{labels.createUser| translate}}<span>*</span></label>
          <label class="radio-holder col-md-2">
            <span>{{labels.yes|translate}}</span>
            <input class="radio" type="radio" name="userCreatePermission" value='Y' [(ngModel)]="selectedPermission"
                   (change)="changePermission($event)">
            <span class="checkmark" data-color="primary"></span>
          </label>

          <label class="radio-holder col-md-3">
            <span>{{labels.no|translate}}</span>
            <input type="radio" name="userCreatePermission" value='N' [(ngModel)]="selectedPermission" class="radio"
                   (change)="changePermission($event)">
            <span class="checkmark" data-color="primary"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="se-dialog-footer">
      <button class="se-button" (click)="cancel()">{{labels.cancel| translate}}</button>
      <button class="se-button button-primary" [disabled]="formInvalid" [ngClass]="{ 'disabled-cls': formInvalid }" (click)="SaveUser(Email)">{{labels.saveAndApp| translate}}</button>
    </div>
  </div>
</div>
